import type { ComputedRef } from 'vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { isPortfolioTreeStrategy } from '@/types/IPortfolioTree';
import { isStrategyFactsheetResponseDTO } from '@/api-v2/web/strategies';
import { useItemUnderAnalysisGlobalState } from './useItemUnderAnalysis';

/**
 * The unique identifier of a portfolio or strategy under analysis
 * WARNING: Only use to get tree draft or when comparing with portfolioTreeOriginalIdentifier
 * transformToUppercase should only be true on the HSBC environment and strategy only pages
 */
export function useIndexUniqueIdentifier(): ComputedRef<string | undefined> {
  const route = useRoute();

  return computed((): string | undefined => {
    return route.params.indexUniqueIdentifier as string | undefined;
  });
}

/**
 * The code of a strategy under analysis
 */
export function useStrategyIdentifier(): ComputedRef<string | null> {
  const { itemUnderAnalysis } = useItemUnderAnalysisGlobalState();

  return computed((): string | null => {
    if (!itemUnderAnalysis.value) return null;

    if (isPortfolioTreeStrategy(itemUnderAnalysis.value) && itemUnderAnalysis.value.strategy)
      return itemUnderAnalysis.value.strategy.code;

    if (isStrategyFactsheetResponseDTO(itemUnderAnalysis.value)) return itemUnderAnalysis.value.strategy.code;

    return null;
  });
}
